/**
 * connectAppOfferKey — THE match key for "is this the same app?" across the
 * whole connect lane, in a module that imports nothing.
 *
 * WHY IT LIVES ALONE (2026-09-20). It is two lines of string handling and it
 * used to sit in connectApp.ts, which imports ComposioClient, which imports
 * `firebase/auth` — and that touches global `fetch` AT IMPORT TIME. So any
 * module reaching for this normalizer inherited the entire Firebase graph, and
 * a test of a PURE helper could not boot without a browser environment and a
 * chain of mocks. That is the load-time trap CLAUDE.md records, and the rule it
 * records with it is this one: put the helper in its own Firebase-free module
 * rather than mocking `firebase/auth` in each suite.
 *
 * ONE IMPLEMENTATION, STILL. connectApp.ts re-exports it, so all of its
 * existing importers are untouched and there is exactly one definition — the
 * property the 2026-08-20 merge established when "RingCentral" and "Ring
 * Central" had to debounce as one app and two sessions fixed it the same day.
 * Never copy these two lines anywhere; import them.
 */

/** Lowercase, strip everything but letters and digits. */
export function connectAppOfferKey(name: string): string {
  return String(name || '').toLowerCase().replace(/[^a-z0-9]/g, '');
}
